import type React from 'react';

import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';

import { useUserProfileUrl } from '#src/app/pages/petitionDetails/shared/hooks';
import type { PetitionDetails } from '#src/app/pages/petitionDetails/shared/types';

export const UserLink: React.FC<{ user: PetitionDetails['user'] }> = ({ user }) => {
	const { data, actions } = useUserProfileUrl();

	if (data.isAnonymous) {
		return (
			<Text
				variant="body"
				fontWeight="bold"
				color="typography-primary"
				className="mb-1"
				data-testid="petition-starter-user"
			>
				{user.displayName}
			</Text>
		);
	}

	return (
		<Link
			href={data.urlLink}
			onClick={actions.onUserNameLinkClick}
			size="medium"
			className="mb-1"
			variant="primary"
			data-testid="user-profile-page-link"
			data-qa="user-profile-page-link"
			color="typography-primary"
			underline={false}
		>
			<Text className="text-typography-strong" size="large" variant="body" fontWeight="bold" color="typography-primary">
				{user.displayName}
			</Text>
		</Link>
	);
};
